<template>
  <div class="app flex-row align-items-center not-found-page">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" class="text-center">
          <div class="clearfix">
            <h1 class="display-3 mb-4">
              <i class="cui-lock-locked"></i>
            </h1>
            <h4 class="pt-3">{{$t('Sesión Expirada.')}}</h4>
           <p class="text-muted">{{$t('Tu sesión ha expirado. Redirigiendo al login...')}}</p>
            <b-spinner variant="primary" class="mt-3" ></b-spinner>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Page401',
  mounted() {
    setTimeout(() => {
      this.$router.push('/pages/login')
    }, 4000)
  },
}
</script>
